import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static values = {
    profileId: String,
    positionsUrl: String,
  }

  connect() {
    this.sortable = Sortable.create(this.element, {
      handle: ".drag-handle",
      draggable: "[data-profile-competency-id]",
      animation: 150,
      ghostClass: "sortable-ghost",
      chosenClass: "sortable-chosen",
      dragClass: "sortable-drag",
      forceFallback: true,
      fallbackOnBody: true,
      onStart: (evt) => evt.item.classList.add("bg-blue-50", "border-blue-300"),
      onEnd: (evt) => {
        evt.item.classList.remove("bg-blue-50", "border-blue-300")
        this.syncPositionInputs()
        this.savePositionsDebounced()
      },
    })
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  }

  syncPositionInputs() {
    const items = this.element.querySelectorAll("[data-profile-competency-id]")
    items.forEach((el, index) => {
      const input = el.querySelector("input[type='number']")
      if (input) input.value = index + 1
    })
  }

  savePositionsDebounced() {
    if (this.saveTimeout) clearTimeout(this.saveTimeout)
    this.saveTimeout = setTimeout(() => this.savePositions(), 300)
  }

  savePositions() {
    if (!this.positionsUrlValue) return
    const ids = Array.from(this.element.querySelectorAll("[data-profile-competency-id]"))
      .map((el) => el.dataset.profileCompetencyId)
      .filter(Boolean)
    if (ids.length === 0) return

    fetch(this.positionsUrlValue, {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content || "",
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "same-origin",
      body: JSON.stringify({ position_ids: ids }),
    })
      .then((res) => {
        if (res.ok) document.dispatchEvent(new CustomEvent("profile:competencies-updated"))
      })
      .catch((err) => console.error("Positionen speichern fehlgeschlagen:", err))
  }
}
